// extracted by mini-css-extract-plugin
module.exports = {"footerBar":"styles_footerBar__ul20V","text":"styles_text__1lYzL","contactLinks":"styles_contactLinks__2trq6","contact":"styles_contact__3TCWB"};